import Translation from '../models/translation';

const en: Translation = {
  title: {
    welcome: 'Welcome to Topii!',
    onBoarding:
      'With Topii you can quickly request remittances to your contacts easily and securely, which will be inmediately credited to your Account.',
    confirmRemittance: 'Confirm Remittance',
    remittanceDetails: 'Remittance Details',
    downloadTopii: 'Download Topii',
    registerTigo: 'Register your RESET account',
    privacyPolicy: 'Privacy Policy',
    userAgreement: 'User Agreement',
  },
  text: {
    welcome: [
      'Now you can chat and quickly request remittances to your contacts easily and safe.',
      'You only have to provide:',
      "1. The person's name and mobile phone number'",
      '2. The amount to request',
      '3. The reason of the remittance request',
    ],
    requestRemittance: 'Request remittance',
    confirmRemittance: 'Are you sure you want to request a remittance?',
    amountRemittance: 'Request amount',
    requesterRemittance: 'Person to request',
    confirmButtonRemittance: 'Confirm',
    remittanceRequested: 'Remittance Requested',
    noteRemittance: 'Note',
    requestedAmountRemittance: 'Requested amount',
    repeatRequestRemittance: 'Repeat Request',
    onBoardingButton: 'START',
    readTerms: 'I have read and accept the ',
    termsOfUse: 'Terms of Use',
    termsAnd: ' and ',
    privacyPolicy: 'Privacy Policy',
    ofTigo: ' of RESET Bank and Topii.',
    personRequest: 'Person to request',
    amountRequest: 'Amount to request',
    reasonRequest: 'Reason to request',
    request: 'Request',
    history: 'History',
    goBack: 'Back',
    namePlaceholder: 'Full Name',
    amountPlaceholder: 'DOP',
    reasonPlaceholder: 'Description',
    canceled: 'Cancelled',
    received: 'Received',
    pending: 'Pending',
    id: 'ID: ****',
    repeatRequest: 'Repeat Request',
    enterPhoneNumber: 'Enter Phone Number',
    haveRequested: 'I have requested a remittance from you in the amount of ',
    byReason: ' Reason:',
    seeDetails: 'See Details',
    writeHere: 'Write Here',
    continue: 'Continue',
    tigoSMS:
      'RESET will send you a confirmation SMS once the remittance has been credited in your Account',
    months: [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ],
    today: 'Today',
    writeSomething: 'Write something...',
    sendRemittanceAttachment: (
      id: string,
      value: string,
      valueConvert: string,
    ) =>
      `I have sent you a remittance for ${value} (${valueConvert}).\n The remittance ID is: ${id}`,
    requestRemittanceAttachment: (value: string, reason: string) =>
      `I have requested you a remittance for ${value}. Description: ${reason}`,
    showDetails: 'Show Details',
    requestChat: 'Start Chat',
    contact: 'Contact',
    addChat: 'Add Chat',
    invite: 'Invite',
    inviteMessage: (name: string) => `Invite ${name} to join Topii`,
    inviteMessageOut: 'I invite you to join Topii topii.com',
    support: 'Help',
    faq: 'Frequently Asked Questions',
    cancel: 'Cancel',
    accept: 'Accept',
    questions: [
      {
        title:
            'How can I request a shipment from Topii?',
        body: 'To request a remittance you need the number of the person to whom you are making the request, the dollar amount and the reason you are requesting the remittance.',
      },
      {
        title: 'How can you send me remittances from Topii?',
        body: 'In order to receive or request remittances, your family member or friend must create a Topii account and you must share your remittance code with them.',
      },
      {
        title:
            'What is the maximum amount of remittances I can request?',
        body: 'The maximum amount you can request is US$500',
      },
      {
        title:
            'How long does it take for remittances to reach my account?',
        body: 'Remittances are reflected in your account immediately, you can use them all at once to pay bills or services and you can withdraw money at ATMs, branches or send money to another person.',
      },
      {
        title: 'How much does it cost to apply for a consignment?',
        body: 'There is no charge for remittance requests.',
      },
      {
        title:
            'In what currency are remittances received?',
        body: 'The money received from remittances will be in Dominican pesos according to the rate of the day.',
      },
      {
        title:
            'From which countries can you send me money?',
        body: 'Remittances are sent from the United States only.',
      },
      {
        title: 'I put the wrong phone number to whom I want to order the remittance, what can I do?',
        body: 'If you enter the wrong number and the person does not have a Topii account, nothing happens.',
      },
      {
        title:
            'Aún no he recibido mi remesa, ¿a dónde escribo?',
        body: 'Sí eres usuario de Reset debes escribir a ayuda@reset.do con tus datos (selfie con cédula en mano, monto solicitado, fecha y hora) y los datos de la persona a quien le solicitaste la remesa (número de celular y nombre). Te recomendamos también que le digas a la persona que envió la remesa coloque un ticket al soporte de Topii.\n',
      },
      {
        title: 'He recibido un correo electrónico de Topii pidiendo mi información financiera. ¿Debo responder enviando la información requerida? ',
        body: 'No, Topii nunca le enviará correo electrónico no solicitado, requiriendo información financiera. Por favor, contáctenos inmediatamente si sospecha que alguien ha suplantado la identidad y está requiriendo información.',
      },
    ],
    questionsTopii: [
      {
        title:
            '¿Cómo puedo recuperar mi nombre de usuario o clave de seguridad?',
        body: 'Puedes recuperar tu contraseña utilizando la opción "Olvidé mi contraseña" desde la página de inicio de sesión. Para recuperar tu usuario, ingresa la dirección de correo electrónico que utilizaste al registrarte.',
      },
      {
        title: '¿Puedo ver el histórico de mis transacciones realizadas?',
        body: 'Sí, cuando accede a Topii puede revisar su histórico de transacciones en el panel de control',
      },
      {
        title:
            '¿Puedo enviar dinero inmediatamente me registre con Topii?\n',
        body: 'Sí, con la creación de su perfil, queda inmediatamente habilitado para realizar envíos a República Dominicana.',
      },
      {
        title:
            '¿Cómo puedo repetir una transacción de envió de dinero que haya realizado con anterioridad?',
        body: 'Puede repetir una transferencia que haya realizado anteriormente, seleccionándola en el histórico de transacciones y utilizando la opción de reenviar (si esta disponible).',
      },
      {
        title: '¿Debo registrarme para poder realizar una transferencia?',
        body: 'Sí, debe completar debidamente el proceso de registro antes de poder realizar transferencias de dinero.',
      },
      {
        title:
            '¿Cómo agrego un beneficiario? ¿Existe un límite en la cantidad de beneficiarios que puedo agregar?',
        body: 'Seleccione la opción “+” en la parte superior de su pantalla y complete la información requerida. No hay limites para los contactos/beneficiarios que puede agregar.',
      },
      {
        title:
            '¿Qué puedo hacer si detecto que los datos de un beneficiario contienen errores una vez haya completado una transacción?',
        body: 'Una vez se ha enviado una transferencia no es posible realizar cambios a la información de la misma. \n' +
            'De todas maneras, si la información del receptor no es válida, la misma será rechazada y los fondos serán retornados a su cuenta para que pueda iniciar una nueva transferencia con la información de beneficiario correcta\n',
      },
      {
        title: '¿A quiénes puedo enviar dinero?',
        body: 'Puede enviar dinero a cualquier persona en República Dominicana que posea un número de identidad nacional válido y un número de teléfono móvil activo.',
      },
      {
        title:
            '¿Qué información acerca de mi beneficiario tengo que suministrar para enviarles una transferencia?',
        body: 'Necesita agregar el nombre, dirección de correo electrónico, país, dirección, código de remesa y número de teléfono móvil. Esta información es requerida cuando se agrega un beneficiario a su lista.',
      },
      {
        title: '¿Qué es un receptor?',
        body: 'Un receptor es una persona a la cual usted esta enviando dinero. El receptor puede ser si esposa, un pariente, un amigo o cualquier persona a la cual usted le envía dinero. Usted puede convertirse en un receptor en el caso que se este enviado dinero a si mismo a su cuenta en Estados Unidos.',
      },
      {
        title: '¿Existe un límite en el número de receptores a quienes puedo enviar dinero?',
        body: 'No, usted puede agregar tantos receptores como desee.',
      },
      {
        title: '¿Por qué los operadores de transferencia de dinero que trabajan con Topii necesitan hacer una verificación de mis datos?',
        body: 'En su calidad de entidad financiera reguladas, se requiere por ley que sean verificados todos sus clientes. Usualmente solo se requiere verificar el nombre, direcciones fecha de nacimiento y una identificación valida.\n' +
            '\n' +
            '\n' +
            'De todas maneras, en algunos casos se podría requerir de información adicional para dar cumplimiento a las obligaciones regulatorias. Nos pondremos en contacto con usted en el evento que se necesite de información adicional.\n',
      },
      {
        title: 'He recibido un correo electrónico de Topii pidiendo mi información financiera. ¿Debo responder enviando la información requerida?',
        body: 'No, Topii nunca le enviará correo electrónico no solicitado, requiriendo información financiera. Por favor, contáctenos inmediatamente si sospecha que alguien ha suplantado la identidad de Topii y esta requiriendo información.',
      },
      {
        title: '¿Cómo puedo dar seguimiento al estado de mi transacción?',
        body: 'Topii le permite seguir en tiempo real el estado de su transacción desde el momento que la envía.',
      },
      {
        title: '¿Puedo cancelar mi transacción de envío de dinero en línea? ¿Existe un costo por cancelación?',
        body: 'Las transacciones de Topii se realizan en tiempo real, una vez se confirma el envía de la remesa, esta no puede ser cancelada o modificada.',
      },
      {
        title: '¿Cómo debo proceder en el evento de que no me sea retornado a la cuenta el monto de una transferencia que no fue acreditada al receptor?',
        body: 'En la sección de ayuda dentro del chat podrás colocar un ticket con los datos solicitados.',
      },
      {
        title: '¿Puedo cancelar o reversar una transferencia completada?',
        body: 'No, no se puede modificar o cancelar una transferencia completada.',
      },
      {
        title: '¿Cómo puedo pagar mi transferencia?',
        body: 'Puede pagar utilizando su cuenta de banco y/o mediante una tarjeta de débito emitida en USA.',
      },
      {
        title: '¿Cómo puedo verificar la tasa de cambio?',
        body: 'Una ves el monto de la transacción y método de pago ha sido completado, la información de tasas y comisiones se despliega en su pantalla antes de confirmar el envío.',
      },
      {
        title: '¿Puedo obtener un recibo por una transferencia realizada?',
        body: 'Si, recibirá un recibo y un número único para cada transacción individual realizada. Puede acceder al recibo al finalizar la operación de envío, el cual puede imprimir o compartir a su conveniencia.',
      },
      {
        title: '¿Están seguros mis fondos con Topii?',
        body: 'Si, los proveedores de servicio de Topii emplean numerosas medidas para asegurar que su dinero así como su información personal este protegida en todo momento utilizando centros de procesamiento altamente seguros para almacenar datos, servicios de atención a cliente para atender inmediatamente dudas e inquietudes, etc. De igual manera, el servicio Topii esta en total cumplimiento con las regulaciones estatales y federales. Por favor revisar los términos y condiciones del servicio.',
      },
      {
        title: '¿Qué sucede si la transacción falla?',
        body: 'Si la transacción falla y el receptor no esta disponible para recibir la transferencia, los fondos serán acreditados a fuente original un plazo no mayor de 2 días laborables.',
      },
      {
        title: '¿A quién debo dirigirme si hay necesidad de arreglos, cambios, cancelaciones, etc.?',
        body: 'En la sección de ayuda dentro del chat podrás colocar un ticket con los datos solicitados.',
      },
      {
        title: '¿Debe estar registrado el receptor en Topii para recibir una transferencia?',
        body: 'No, el receptor no tiene que estar registrado con CHAPii Chat para recibir una transferencia; es altamente recomendable que se registre a fin de disfrutar el servicio y beneficios de punta a punta que esta ofrece.',
      },
      {
        title: '¿Cómo sé que mi transferencia fue exitosa?',
        body: 'Puede ver el estado de la transacción en tiempo real e su pantalla, desde el mismo momento en que ordena la ejecución de la transacción.',
      },
      {
        title: '¿Dónde encuentro información sobre las tasas de cambio de monedas?',
        body: 'Después de ingresar el monto que le gustaría enviar, puede ver el equivalente en moneda local del receptos justo al lado del valor en dólares. Esta información es valida solamente para la operación en curso.',
      },
      {
        title: '¿Como el receptor recibe el dinero enviado por vía de Topii?',
        body: 'El dinero será acreditado en la cuenta de monedero electrónico del beneficiario.',
      },
      {
        title: '¿Puedo enviar dinero fuera del horario de servicios bancarios? ¿Existe alguna dilación si envío dinero fuera de horario de servicio bancario?',
        body: 'Si, puede enviar dinero en tiempo real las 24 horas los 7 días de la semana. Para servicio al cliente por favor refiérase al horario publicado.',
      },
      {
        title: '¿Puedo enviar y recibir dinero de cualquier país a través de Topii?',
        body: 'Actualmente puede enviar dinero desde todos los Estados Unidos de Norteamérica hacia República Dominicana. Se irán incorporando mas países paulatinamente.',
      },
      {
        title: '¿Puedo enviar dinero a cualquier banco?',
        body: 'Actualmente solo puede enviarse dinero para ser acreditado en los monederos electrónicos de RESET.',
      },
      {
        title: '¿Qué tiempo toma la ejecución de una transferencia?',
        body: 'La mayoría de las remesas se completan dentro de un plazo de 2 minutos. De todas maneras, algunas transacciones pueden presentar retrasos en el evento que la información de quien envía y de quien recibe requiera de confirmación adicional de acuerdo con los entes reguladores actuantes tanto en el país de origen como el de destino.',
      },
      {
        title: '¿Por qué retornaron los fondos de la transferencia a mi cuenta? ¿Qué debo hacer?',
        body: 'Sus fondos pueden haber sido retornados por varias razones. Por ejemplo, la información de la cuenta del receptor no estaba correcta o la cuento no esta disponible, o, la transacción fue objetada por la verificación regulatoria. Se enviará un correo electrónico al ordenante indicando las razones por la cual no se pudo ejecutar la transferencia.',
      },
      {
        title: '¿En qué moneda se recibirá el receptor el dinero enviado?',
        body: 'El receptor recibirá el dinero enviado en la moneda nacional del país al que fue enviada la transferencia.',
      },
      {
        title: '¿Puedo cambiar la información del receptor?',
        body: 'Sí, puede modificar la información del receptor.',
      },

    ],
    warning: 'Warning',
    deleteMessage: 'Do you want to delete the chat?',
    archive: 'Archive',
    delete: 'Delete',
    close: 'Close',
    clientError:
      'There was an error with your internet connection. Please, try again later',
    serverError:
      'There was an error connecting to the server. Please, try again later',
    registerTigoMsg:
      'Introduce your data in the following fields exactly as they appear in your RESET account. Do not add accents, eñes or diacritics',
    firstName: 'First Name',
    firstNamePlaceholder: 'Write your first name here',
    middleName: 'Middle Name',
    middleNamePlaceholder: 'Write your middle name here',
    firstLastName: 'First Last Name',
    firstLastNamePlaceholder: 'Write your first last name here',
    secondLastName: 'Second Last Name',
    secondLastNamePlaceholder: 'Write your second last name here',
    birthDate: 'Birth date',
    birthDatePlaceholder: 'YYYY-MM-DD',
    birthDateMax: 'You have to be 18 or older to use Topii',
    city: 'City',
    cityPlaceholder: 'Write your city here',
    province: 'Province',
    provincPlaceholder: 'Write your province here',
    phoneNumber: 'Phone Number',
    validField: (value: string) => `${value} has to be a valid field`,
    requiredField: (value: string) => `${value} is a required field`,
    characterValidField: (value: string) =>
      `${value} cannot contain accents, eñes or diacritics`,
    confirmRegistry: 'Please check that your data has been entered correctly',
    edit: 'Edit',
    error: 'Error',
    invalidPhoneNumber: 'The phone number is invalid',
    minAmount: (value: number) => `The minimum amount is ${value}`,
    maxAmount: (value: number) => `The maximum amount is ${value}`,
    receivedRemittance: 'Remittance Received',
    sender: 'Sender',
    receivedAmountRemittance: 'Received Amount',
    requested: 'Requested',
    noRemittances: 'Empty history',
    codeRemittance: 'Remittance Code',
    topiiUsers: 'Topii Users',
    resetUsers: 'Reset Users',
    ohOh: 'Oh Oh!',
    serviceOnManteinance: 'The service is under maintenance'
  },
};

export default en;
